import { Link, createFileRoute } from "@tanstack/react-router";

import { ScheduleForm } from "~/components/ScheduleForm";
import { useI18n } from "~/lib/i18n";
import { ui } from "~/lib/ui";

export const Route = createFileRoute("/operator/schedules/new")({
  component: NewSchedule,
});

function NewSchedule() {
  const { t } = useI18n();

  return (
    <div className="mx-auto max-w-xl space-y-4">
      <Link to="/operator/schedules" className="text-sm text-ink underline-offset-2 hover:underline dark:text-ink-dark">
        <span aria-hidden="true">← </span>
        {t("allSchedules")}
      </Link>
      <h1 className={ui.h1}>{t("addSchedule")}</h1>
      <ScheduleForm />
    </div>
  );
}
